export default __webpack_public_path__ + "static/realWorldImg1-016bc523733b6f8b39112279fcdf2314.webp";